import * as types from './mutation-types.js'
import analytics from '@/services/api/analytics.js'
import { getAnalyticsOptions } from '../../helpers'
import { getOverlapCsvUrl } from '@/services/api/analytics.helpers.js'

// initial state
const state = () => ({
  loading: false,
  collection: [],
  csv: null
})

const getters = {

}

const actions = {
  async getOverlapComparison ({ commit, rootState, rootGetters }, { compare, params }) {
    let options = getAnalyticsOptions(rootState, rootGetters, compare, true)
    const dataOptions = {
      ...options,
      ...params
    }
    commit('CLEAR_API_CALLS', {}, { root: true })
    commit(types.CLEAR_OVERLAP)
    commit(types.LOADING_OVERLAP)
    await analytics.getOverlap(dataOptions).then((data) => {
      commit(types.SET_OVERLAP, data)
      commit('ADD_API_CALLS', {
        overlap: {
          href: data.href,
          time: new Date().toUTCString()
        }
      }, { root: true })
    })
    commit(types.SET_OVERLAP_CSV, getOverlapCsvUrl(options))
  }
}

const mutations = {
  [types.CLEAR_OVERLAP] (state) {
    state.collection = []
    state.csv = null
  },
  [types.LOADING_OVERLAP] (state) {
    state.loading = true
  },
  [types.SET_OVERLAP] (state, data) {
    state.collection = data
    state.loading = false
  },
  [types.SET_OVERLAP_CSV] (state, csv) {
    state.csv = csv
  }
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
}
